import React from 'react'
import { Outlet } from 'react-router-dom'

import { Header } from '@/components/layout'
import { Sidebar } from '@/components/layout'
import { BreadcrumbProvider } from '@/contexts/BreadcrumbProvider'

export const AdminLayout: React.FC = () => {
  return (
    <BreadcrumbProvider>
      <div className="flex h-screen bg-gray-50">
        <Sidebar currentModule="admin" />

        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />

          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbProvider>
  )
}
